import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from './Sidebar_Coral.module.css';
import { FaFileMedicalAlt } from "react-icons/fa";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitialstates_coral';
import useHttp from '../../../hook/use-http';
import { decodeToken } from "react-jwt";

function Sidebar_Coral() {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [isRealTimeDashboard, setIsRealTimeDashboard] = useState(false)

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "vehicleinsights"
      }
    })
  }, []);

  useEffect(() => {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const usernameNew = decodedToken.access_type;
    var split_str = usernameNew.split(",");
    if (split_str.indexOf("4") !== -1) {
      setIsRealTimeDashboard(true)
    }
  }, [isRealTimeDashboard]);

  return (
    <>

      <nav className="main-menu" style={{ zIndex: 10000 }}>
        <ul style={{ padding: 0 }}>
          <li>
            <Link to="/homepage"><i className="metismenu-icon"><img src="/assets/img/ic_dashboard_bl.png" width={20} height={20} /></i></Link>
          </li>
          <li>
            <Link to="/VehicleInsights_Coral"><i className="metismenu-icon"><img src="/assets/img/ic_fleet.png" width={20} height={20} /> </i></Link>
          </li>
          {
            isRealTimeDashboard &&
            <li>
              <Link to="/realtime_Coral"><i className="metismenu-icon"><FaFileMedicalAlt style={{ width: '20px', height: '20px' }} /></i></Link>
            </li>
          }
        </ul>
      </nav>
    </>

  );
}

export default Sidebar_Coral;